module.exports = __webpack_public_path__ + "static/media/cacao-basket.ef210d3c.jpg";